import { List, Table } from "antd";
import { AddNote } from "../add-note";
import { DateFormate } from "@/util/params";
import { DisputedTranService } from "@/services/disputed";
import { useState, useEffect } from "react";

export const AttachmentList = (props: any) => {
    const [attachmentList, setAttachmentList] = useState([]);
    const [noteList, setNoteList] = useState([]);

    const fetchAttachmentList = async (id: any) => {
        try {
            const res = await DisputedTranService.getAttachmentList(id);
            setAttachmentList(res.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchNotesList = async (id: any) => {
        try {
            const res = await DisputedTranService.getNoteList(id);
            setNoteList(res.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    // Load attachment + notes
    useEffect(() => {
        if (props.complaintId) {
            fetchAttachmentList(props.complaintId);
            fetchNotesList(props.complaintId);
        }
    }, [props.complaintId]);

    const columns = [
        {
            title: 'Date and Time',
            dataIndex: 'created_date',
            key: 'created_date',
            render: (val: any) => (
                <span>
                    {DateFormate(val)}
                </span>
            )
        },
        {
            title: 'Added By',
            dataIndex: 'created_by',
            key: 'created_by',
        },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
        }
    ];
    const formatFileSize = (bytes: number) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };
    return (
        <div>
            {/* ATTACHMENTS LIST */}
            <div className="">
                {attachmentList.length > 0 && (
                    <div style={{ borderTop: '1px solid #D7D7D7' }} >
                        <div style={{ paddingTop: "20px" }}>
                            <List
                                bordered
                                dataSource={attachmentList}
                                renderItem={(file: any) => {


                                    return (
                                        <List.Item
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "10px 15px",
                                                // minHeight: "40px",
                                            }}

                                        >

                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <div>
                                                    <span style={{ fontWeight: 600, fontSize: "12px" }}>
                                                        {file.document_category}
                                                    </span>

                                                    <br />
                                                    <span style={{
                                                        // maxWidth: "225px",
                                                        width: "300px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "inline-block",
                                                    }}>
                                                        {file.file_name}
                                                    </span>
                                                </div>
                                            </div>

                                            <span style={{ fontSize: "10px" }}>
                                                {formatFileSize(file.size)}
                                            </span>
                                            <div style={{ fontSize: "10px" }}>
                                                <span>{DateFormate(file.created_date)}</span>
                                            </div>
                                        </List.Item>
                                    );
                                }}
                            />
                        </div>
                    </div>


                )}
            </div>



            {/* NOTES LIST */}
            <div >
                {noteList.length > 0 && (
                    <div style={{ paddingTop: 20 }}>
                        <div style={{ borderTop: '1px solid #D7D7D7', paddingTop: 20 }}>
                            <Table
                                pagination={false}
                                dataSource={noteList}
                                columns={columns}
                            />
                        </div>
                    </div>


                )}
            </div>

            {/* ADD NOTE */}
            <AddNote
                complaintID={props.complaintId}
                onNoteAdded={() => fetchNotesList(props.complaintId)}
            />
        </div>
    );
};
